var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveDictionary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_2921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2534 2.16291C21.6833 1.68727 21.0145 1.34456 20.2955 1.15965C19.5764 0.974744 18.8252 0.952287 18.0964 1.09391L16.3324 1.52591C15.4118 1.69461 14.5796 2.18075 13.9805 2.89973C13.3813 3.61872 13.0533 4.52502 13.0534 5.46091V20.9279C12.3903 21.0249 11.7165 21.0249 11.0534 20.9279V5.46091C11.0567 4.53365 10.7363 3.63432 10.1473 2.91812C9.55834 2.20191 8.73784 1.71376 7.82741 1.53791L5.95341 1.08191C5.23256 0.950005 4.49154 0.978161 3.78278 1.16439C3.07403 1.35061 2.41487 1.69036 1.85197 2.15956C1.28907 2.62877 0.836192 3.21598 0.525388 3.87962C0.214584 4.54326 0.0534546 5.2671 0.0534058 5.99991L0.0534058 16.7929C0.0534632 17.9637 0.464382 19.0974 1.21454 19.9963C1.9647 20.8952 3.00652 21.5023 4.15841 21.7119L10.4444 22.8549C11.5084 23.0482 12.5985 23.0482 13.6624 22.8549L19.9534 21.7119C21.1044 21.5013 22.145 20.8937 22.8942 19.9949C23.6434 19.0961 24.0536 17.963 24.0534 16.7929V5.99991C24.0539 5.26736 23.8928 4.54371 23.5817 3.8805C23.2706 3.2173 22.817 2.63085 22.2534 2.16291Z",
    fill: "#1DB469"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_2921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.0534058)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDictionary);
export default __webpack_public_path__ + "static/media/activeDictionary.4bedd80e2cd6764ddbb4ab393b855dc2.svg";
export { ForwardRef as ReactComponent };